<template>
  <v-row>
    <v-col>
      <h2 class="pl-2 pa-sm-0 primary--text">
        {{ $translate('ENTER_YOUR_EMAIL') }}
      </h2>

      <v-row justify="center">
        <v-col cols="12" md="5">
          <h3>{{ $translate('ENTER_YOUR_EMAIL') }}</h3>
          <p>{{ $translate('EMAIL_WHY') }}</p>
          <v-form ref="form">
            <v-text-field
              v-model="email"
              class="pt-1"
              outlined
              dense
              :label="$translate('EMAIL')"
              :rules="emailRules"
              @keydown.enter="continueBooking"
            />
            <v-text-field
              v-model="confirmEmail"
              class="pt-1"
              outlined
              dense
              :label="$translate('CONFIRM_EMAIL')"
              :rules="confirmEmailRules"
              @keydown.enter="continueBooking"
              @paste="onPasteConfirmEmail"
            />
            <v-btn
              depressed
              block
              color="primary"
              class="primary-font-color mt-3"
              @click="continueBooking"
            >
              {{ $translate('CONTINUE') }}
            </v-btn>
          </v-form>
        </v-col>
      </v-row>

      <v-row class="mt-7">
        <v-btn color="secondary" dark class="white--text" @click="goBack">
          {{ $translate('BACK') }}
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { requiredRules, emailRules } from '@/shared/validations_rules';

export default {
  name: 'Booking_Order_Email',
  props: {},
  data() {
    return {
      email: '',
      confirmEmail: '',
      productShoppingCart: [],
      emailRules: [...requiredRules, ...emailRules],
      confirmEmailRules: [
        ...requiredRules,
        ...emailRules,
        (v) => v === this.email || this.$translate('EMAIL_NO_MATCH'),
      ],
    };
  },
  created() {
    // hide the header and footer in the booking process when entering the page
    this.$store.commit('setHideHeaderAndFooter', true);
  },
  mounted() {
    this.email = this.$store.getters['auth/tmpEmail'];
    this.productShoppingCart = this.$store.getters[
      'shoppingCart/orders'
    ].filter((item) => item.ShoppingCartType === 'Product');
  },
  methods: {
    continueBooking() {
      if (!this.$refs.form.validate()) {
        window.EventBus.fire('activateSnackBar', {
          text: this.$translate('LINDA_FILL_REQUIRED'),
          color: 'warning',
        });
        return;
      }
      this.$emit('continue', this.email);
      this.$store.commit('auth/setTmpEmail', this.email);
    },
    goBack() {
      this.$store.commit('setHideHeaderAndFooter', false);
      this.$emit('back');
    },
    onPasteConfirmEmail(e) {
      // Paste confirm email is not allowed
      e.preventDefault();
    },
  },
};
</script>
